import {
  useState,
  useMemo,
} from "react"
import type { ReactNode } from "react"

import { InsightsContext } from "./InsightsContext"
import { InsightsState } from "src/types"

interface Props {
  children: ReactNode;
}

export function InsightsContextProvider(props: Props) {
  const [
    insightsState,
    setInsightsState,
  ] = useState<InsightsState>(InsightsState.Default)

  const contextValue = useMemo(
    () => ({
      insightsState,
      setInsightsState,
    }),
    [
      insightsState,
      setInsightsState,
    ],
  )

  return (
    <InsightsContext.Provider value={contextValue}>
      {props.children}
    </InsightsContext.Provider>
  )
}
